(ns frontend.view.kpi-reporting.kpi-company-reports.view
  (:require-macros [frontend.macros :refer [without-default-action-and-propagation]])
  (:require
   [basic-components.popover :as popover]
   [clojure.string :as string]
   [common.currencies :as currencies]
   [common.entity :as entity]
   [common.features.plan :as plan]
   [common.localization :as loc]
   [common.util :as cu :refer [flip]]
   [frontend.bootstrap.components :as rbs]
   [frontend.page-components.default-page-layout :as default-page-layout]
   [frontend.page-components.zap-toolbar :as zap-toolbar]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.utils :as fu]
   [frontend.view.components.form.components.form-label :as form-label]
   [frontend.view.components.form.view :as form]
   [frontend.view.components.upload :as upload]
   [frontend.view.kpi-reporting.kpi-company-reports.company-sidenav :as company-sidenav]
   [frontend.view.kpi-reporting.kpi-company-reports.db :as db]
   [frontend.view.kpi-reporting.kpi-company-reports.events :as events]
   [frontend.view.modals.delete-confirmation.view :as delete-confirmation-modal]
   [frontend.view.modals.events :as modals]
   [frontend.view.not-found :as not-found]
   [potpuri.core :refer [deep-merge fn-> fn->> index-by]]
   [reagent.core :as r]
   [ui.components.button.view :as button]
   [ui.editors.data-input :as data-input]))

(defn send-reminder-button
  [report]
  {:toolbar-button?  true
   :dropdown-action? true
   :ord              3
   :icon             :fa-paper-plane
   :primary-button?  true
   :on-select        #(events/send-reminder! report)
   :tooltip-text     (loc/tr :kpi-report/tooltip-send-reminder)
   :label            (loc/tr :kpi-report/button-send-reminder)})

(defn set-as-submitted-button
  [report]
  {:toolbar-button?  true
   :dropdown-action? true
   :ord              5
   :icon             :fa-paper-plane
   :primary-button?  false
   :on-select        #(events/submit-report! report)
   :tooltip-text     (loc/tr :kpi-report/tooltip-submit)
   :label            (loc/tr :kpi-report/button-submit)})

(defn request-revision-button
  [report]
  {:toolbar-button?  true
   :dropdown-action? true
   :ord              2
   :icon             :fa-paper-plane
   :primary-button?  true
   :on-select        #(events/request-revision! report)
   :tooltip-text     (loc/tr :kpi-report/tooltip-request-revision)
   :label            (loc/tr :kpi-report/button-request-revision)})

(defn approve-and-lock-button
  [report]
  {:toolbar-button?  true
   :dropdown-action? true
   :ord              4
   :icon             :fa-paper-plane
   :primary-button?  true
   :on-select        #(events/review-report! report)
   :tooltip-text     (loc/tr :kpi-report/tooltip-review-report)
   :label            (loc/tr :kpi-report/button-approve-and-lock)})

(defn unlock-button
  [report]
  {:toolbar-button?  true
   :dropdown-action? true
   :ord              1
   :icon             :fa-paper-plane
   :primary-button?  true
   :on-select        #(events/unlock-report! report)
   :tooltip-text     (loc/tr :kpi-report/tooltip-unlock)
   :label            (loc/tr :kpi-report/button-unlock)})

(defn delete-button
  [report]
  {:toolbar-button?  false
   :dropdown-action? true
   :ord              25
   :icon             :fa-trash
   :primary-button?  false
   :on-select        #(events/delete-selected-report! report)
   :label            (loc/tr :delete-kpi-report-menu-item)})

(defn toolbar-actions
  [{:keys [report cycle]}]
  (when-not (session/is-read-only-user?)
    (let [;;report (events/selected-report)
          report-status (:kpi-report/status report)
          ;;TODO mode will be :monthly vs :quarterly in the future
          mode :company
          #_@db/mode]
      [(when report
         {:toolbar-button?  true
          :dropdown-action? true
          :ord              20
          :primary-button?  false
          :on-select        (fn [e]
                              (events/copy-to-clipboard report cycle))
          :label            (loc/tr :copy-to-clipboard)})
       (when report
         {:toolbar-button?  true
          :dropdown-action? true
          :ord              15
          :primary-button?  false
          :on-select        (fn [e]
                              (events/export-to-excel report cycle))
          :label            (loc/tr :action/export)})

       (when (= report-status :kpi-report.status/wip)
         (send-reminder-button report))
       (when (or (= report-status :kpi-report.status/wip)
                 (= report-status :kpi-report.status/submitted))
         (approve-and-lock-button report))
       (when (= report-status :kpi-report.status/submitted)
         (request-revision-button report))
       (when (= report-status :kpi-report.status/reviewed)
         (unlock-button report))
       (when report
         (delete-button report))])))

(defn guest-toolbar-actions
  [{:keys [report cycle]}]
  (let [status (:kpi-report/status report)
        ;;guest only sees 'WIP' - other states considered as 'submitted'
        wip? (= status :kpi-report.status/wip)]
    [(when report
       {:toolbar-button?  true
        :dropdown-action? true
        :ord              20
        :primary-button?  false
        :on-select        (fn [e]
                            (events/copy-to-clipboard report cycle))
        :label            (loc/tr :copy-to-clipboard)})
     (when report
       {:toolbar-button?  true
        :dropdown-action? true
        :ord              15
        :primary-button?  false
        :on-select        (fn [e]
                            (events/export-to-excel report cycle))
        :label            (loc/tr :action/export)})
     (when wip?
       {:toolbar-button?  true
        :dropdown-action? true
        :ord              10
        :primary-button?  true
        :label            (loc/tr :submit)
        :on-select        (fn [e]
                            (events/confirm-submit-report! report))})]))

(defn navigation-elems
  [company state]
  [:span
   [:a
    {:href     (routing/path-for :kpi-categories)
     :on-click (without-default-action-and-propagation
                (routing/set-view! [:kpi-categories]))}
    (loc/tr :kpi-company-reports/sub-navbar-heading)]
   " > " (:asset/name company)])

(defn guest-navigation-elems
  [company state]
  (loc/tr :kpi-reports/guest-navbar-heading [(:asset/name company)]))

;;TODO not in first release.
;; will be :monthly vs :quarterly
;; (:quarterly is simply calculated => only available for non-writable statuses?)
(defn mode-selector
  [state]
  (let [mode (:mode @state)]
    [:div.view-mode-switch
     [:span
      {:class-name (fu/cs "view-mode"
                          (when (= mode :company)
                            "selected"))
       :on-click   (partial events/set-mode! :company)}
      [:i.fal.fa-building]
      [:span (loc/tr :kpi-summary/company-view)]]

     [:span
      {:class-name (fu/cs "view-mode"
                          (when-not (= mode :company)
                            "selected"))
       :on-click   (partial events/set-mode! :reporting-cycle)}
      [:i.fal.fa-file-chart-line]
      [:span (loc/tr :kpi-summary/reporting-cycle-view)]]]))

(defn guest-report-header
  [{:keys [report kpi-cycle]}]
  (let [target-year (:kpi-cycle/target-year kpi-cycle)
        target-month (:kpi-cycle/target-month kpi-cycle)
        period-str (str target-year "/" target-month)
        status (:kpi-report/status report)
        guest-status (if (= status :kpi-report.status/wip)
                       :kpi-reports/guest-status-wip
                       :kpi-reports/guest-status-submitted)]
    [:div
     {:class "m-0 flex gap-3 px-2 pt-3 pb-2 text-sm"}
     [:span (loc/tr :kpi-cycle/target-month) ": "
      [:span
       {:class "font-semibold"}
       period-str]]
     [:span (loc/tr :kpi-report/status) ": "
      [:span
       {:class "font-semibold"}
       (loc/tr guest-status)]]]))

(defn status-view
  [status]
  (let [texts {:kpi-report.status/wip       (loc/tr :pending-their-submit)
               :kpi-report.status/submitted (loc/tr :pending-our-review)
               :kpi-report.status/reviewed  (loc/tr :our-review-complete)}
        text (get texts status)]
    [:span (loc/tr :kpi-report/status) ": "
     [:span
      {:class "font-semibold"}
      text]]))

(defn report-header
  [{:keys [report kpi-cycle]}]
  (let [their-contact (->> report
                           :kpi-report/contact-account
                           (get @session/entities)
                           entity/display-string)
        our-contact (->> report
                         :common/owner
                         (get @session/entities)
                         entity/display-string)
        target-year (:kpi-cycle/target-year kpi-cycle)
        target-month (:kpi-cycle/target-month kpi-cycle)
        period-str (str target-year "/" target-month)
        status (:kpi-report/status report)]
    [:div
     {:class "m-0 flex gap-3 px-2 pt-3 pb-2 text-sm"}
     [status-view status]
     [:span (loc/tr :kpi-cycle/target-month) ": "
      [:span
       {:class "font-bold"}
       period-str]]
     [:span (loc/tr :their-contact) ": "
      [:span
       {:class "font-bold"}
       their-contact]]
     [:span (loc/tr :our-contact) ": "
      [:span
       {:class "font-bold"}
       our-contact]]]))

(defn internal-note
  [{:keys [report]}]
  (let [internal-note (-> @db/state
                          (get (:db/id report))
                          :internal-note)]
    [:div.kpi-internal-note
     [form/view
      {:label            (loc/tr :kpi-report/internal-note)
       :wrapper
       "kpi-questions-textarea kpi-internal-note-textarea zap-form__light-grey__green__dark-grey"
       :type             "textarea"
       :edit?            true
       :read-only?       (session/is-read-only-user?)
       :empty-on-submit? true
       :value            (or internal-note (:kpi-report/internal-note report))
       :on-change!       (partial events/update-internal-note! report)
       :on-save!         (partial events/save-internal-note! report)
       :cancel-edit!     identity
       :control-id       (str "form-internal-note")}]]))

(defn currency-field
  [{:keys [kpi-report/currency] :as report} writable?]
  [data-input/view
   {:editor-type   :editor.type/select
    :data-type     :data.type/keyword
    :is-clearable? false
    :full-width?   true
    :read-only?    (not writable?)
    :disabled?     (not writable?)
    :value         currency
    :options       currencies/value-options
    :on-change     (fn [new-value & _]
                     (events/save-currency!
                      report
                      new-value
                      (fn [_])
                      (fn [_])))}])

(defn kpi-table
  [{:keys [report kpi-cycle datas is-guest?]}]
  (let [kpis (fu/ordered-grouped-kpis report)
        {:keys [:db/id kpi-report/granularity kpi-report/forecast-requested?
                kpi-report/target-period kpi-report/target-year kpi-report/status]}
        report
        {:keys [kpi-cycle/target-year kpi-cycle/target-month]} kpi-cycle
        writable? (and (not (session/is-read-only-user?))
                       (if is-guest?
                         (= status :kpi-report.status/wip)
                         (#{:kpi-report.status/draft
                            :kpi-report.status/wip
                            :kpi-report.status/submitted}
                          status)))
        all-yperiods (cu/yperiods :monthly false target-year target-month)]
    (when-not (empty? kpis)
      [:div.table-responsive.bgr-grey
       [rbs/Table
        {:striped    true
         :bordered   true
         :hover      true
         :class-name (fu/cs "zapflow-table" "table-sm" "kpi-table")}
        [:thead.kpi-report-view-table-header
         [:tr
          [:th.currency-cell [currency-field report writable?]]
          (for [[year period] all-yperiods]
            ^{:key (str "report-table-header-cell-" year period)}
            [:th
             (str (when (= granularity :quarterly) "Q")
                  period
                  "/"
                  year)])]]
        [:tbody
         (doall
          (for [kpi-el kpis
                :let [kpi (:kw kpi-el)
                      separator? (cu/separator-kw? kpi)
                      guidance (->> report
                                    :kpi-report/user-guidances
                                    kpi)
                      tooltip (when-not (or (empty? guidance)
                                            separator?)
                                guidance)
                      kpi-label (fu/kpi-str kpi-el)]]
            (if separator?
              ^{:key (str "kpi-row-" kpi)}
              [:tr.kpi-group-heading-row
               [:td.kpi-group-heading-cell.sticky-col
                ; {:col-span (str (inc (count all-yperiods)))}
                guidance]]
              ^{:key (str "kpi-row-" kpi)}
              [:tr
               [:td.sticky-col
                [popover/view nil kpi-label
                 [:span
                  {:class "inline-flex pr-2"}
                  kpi-label]
                 false {:placement "bottom"}]
                (when tooltip
                  [button/square-secondary-open
                   {:tooltip tooltip}
                   [:i.fal.fa-question-circle]])]
               (doall
                (for [[year period] all-yperiods
                      :let [data (->> datas
                                      (cu/only-entity :kpi-report-data/kpi kpi)
                                      (cu/only-entity :kpi-report-data/year year)
                                      (cu/only-entity :kpi-report-data/period period)
                                      (sort-by :common/updated-on)
                                      last)
                            value (->> data
                                       :kpi-report-data/value
                                       fu/bigdec->float)]]
                  ^{:key (str "report-view-col-" (:db/id report) year period kpi)}
                  [:td
                   {:class-name (fu/cs "kpi-table-cell"
                                       (when-not writable? "kpi-read-only"))}
                   (if writable?
                     [form/view
                      {:type                "numeric"
                       :edit?               true
                       :hide-cancel-button? true
                       :empty-on-submit?    true
                       :value               (or (get-in @db/state [:edit-data id year period kpi])
                                                value)
                       :wrapper             "kpi-table-form"
                       :on-change!          (partial events/update-data! id [year period kpi])
                       :on-save!            (partial events/save-data! id [year period kpi])
                       :cancel-edit!        identity
                       :control-id          (str "form-" year period kpi)}]
                     [:div
                      {:class-name "px-4"}
                      (if value
                        (fu/format-with-separators value)
                        "")])]))])))]]])))

(defn questions-view
  [{:keys [report answers is-guest?]}]
  (let [questions (fu/ordered-grouped-questions report)
        {:keys [db/id kpi-report/granularity kpi-report/forecast-requested?
                kpi-report/target-period kpi-report/target-year kpi-report/status]}
        report
        writable? (and (not (session/is-read-only-user?))
                       (if is-guest?
                         (= status :kpi-report.status/wip)
                         (#{:kpi-report.status/draft
                            :kpi-report.status/wip
                            :kpi-report.status/submitted}
                          status)))]
    (when-not (empty? questions)
      [:div.kpi-questions
       (doall
        (for [question questions
              :let [kw (:kw question)
                    separator? (cu/separator-kw? kw)
                    answer (->> answers
                                (cu/only-entity :kpi-report-answer/question kw)
                                first
                                :kpi-report-answer/response)
                    guidance (->> report
                                  :kpi-report/user-guidances
                                  kw)
                    tooltip (when-not (or (empty? guidance)
                                          separator?)
                              (r/as-element
                               [rbs/Tooltip
                                {:class "in"
                                 :id    (str "kpi-qualitative-user-guidance-tooltip-" kw)}
                                guidance]))]]
          (cond
            separator?
            ^{:key (str "kpi-quantitative-field-" kw)}
            [:div.question-group-heading
             guidance]
            writable?
            ^{:key (str "kpi-quantitative-field-" kw)}
            [form/view
             {:label            (fu/kpi-str question)
              :extra-builder    (fn [_]
                                  (when tooltip
                                    [rbs/OverlayTrigger
                                     {:placement     "top"
                                      :popper-config {:modifiers [{:name    "preventOverflow"
                                                                   :options {:main-axis false}}
                                                                  {:name "hide"}]}
                                      :overlay       tooltip}
                                     [:i.fal.fa-question-circle]]))
              :wrapper          "kpi-questions-textarea zap-form__light-grey__green__dark-grey"
              :type             "textarea"
              :edit?            true
              :empty-on-submit? true
              :value            (or (get-in @db/state [:edit-answer id kw]) answer)
              :on-change!       (partial events/update-answer! id kw)
              :on-save!         (partial events/save-answer! id kw)
              :cancel-edit!     identity
              :control-id       (str "form-" kw)}]
            :else
            ^{:key (str "kpi-quantitative-field-" kw)}
            [rbs/FormGroup
             {:control-id (str "form-" kw)
              :class-name "form__textarea"}
             [form-label/view
              {:label         (fu/kpi-str question)
               :extra-builder (fn [_]
                                (when tooltip
                                  [rbs/OverlayTrigger
                                   {:placement     "top"
                                    :popper-config {:modifiers [{:name    "preventOverflow"
                                                                 :options {:main-axis false}}
                                                                {:name "hide"}]}
                                    :overlay       tooltip}
                                   [:i.fal.fa-question-circle]]))}]
             [:div answer]])))])))

(defn attachment-view
  [{:keys [attachment target prevent-upload?]}]
  (let [{:keys [attachment/filename]} attachment]
    [rbs/ListGroupItem
     {:class "kpi-attachment"}
     [:div.kpi-attachment-left
      {:on-click #(fu/open-attachment! (:db/id attachment))}
      [:i.fal.fa-paperclip.kpi-attachment-icon]
      [:span.kpi-attachment-filename filename]]
     [:div.kpi-attachment-right
      (when-not prevent-upload?
        [:div.inline-flex.gap-3
         [button/square-secondary-open
          {:on-click (without-default-action-and-propagation
                      (modals/open-modal!
                       delete-confirmation-modal/modal-key
                       {:body       (loc/tr :attachment-delete)
                        :on-delete! #(events/remove-attachment! target attachment)}))}
          [:i.fal.fa-trash-alt]]])]]))

(defn attachments-view
  [{:keys [attachments kpi-report prevent-upload?]}]
  [:div.kpi-attachments
   (if prevent-upload?
     [:div.kpi-upload-not-allowed (loc/tr :upload-not-allowed)]
     [upload/upload-zone
      {:css-class  "kpi-upload-zone"
       :on-change! (partial events/add-attachment! kpi-report)}])
   [:div.kpi-attachments-list
    [rbs/ListGroup
     (doall
      (for [attachment attachments]
        ^{:key (str "attachment-view_" (:db/id attachment))}
        [attachment-view
         {:attachment      attachment
          :target          kpi-report
          :prevent-upload? prevent-upload?}]))]]])

(defn report-view
  [{:keys [company report kpi-cycle loading? datas answers is-guest?]}]
  (let [kpis (fu/ordered-kpis report)
        {:keys [kpi-report/granularity kpi-report/forecast-requested?
                kpi-report/target-period kpi-report/target-year kpi-report/status]}
        report
        {:keys [kpi-cycle/target-year kpi-cycle/target-month]} kpi-cycle
        all-reports (events/company-reports (:db/id company))
        attachments (->> report
                         :common/attachments
                         (keep (fn->> (get @session/entities)))
                         (sort-by :common/created-on)
                         reverse)
        prevent-upload? (or (session/is-read-only-user?)
                            (and is-guest?
                                 (not= status :kpi-report.status/wip)))
        all-yperiods (cu/yperiods :monthly false target-year target-month)]
    (if report
      [:div

       (if is-guest?
         [guest-report-header
          {:report    report
           :kpi-cycle kpi-cycle}]
         [report-header
          {:report    report
           :kpi-cycle kpi-cycle}])

       [kpi-table
        {:report    report
         :is-guest? is-guest?
         :kpi-cycle kpi-cycle
         :datas     datas}]

       [:div
        {:class "grid grid-cols-2 gap-4"}
        [:div
         (when-not is-guest?
           [internal-note {:report report}])
         [questions-view
          {:report    report
           :is-guest? is-guest?
           :answers   answers}]]]

       [:div
        {:class "grid grid-cols-2 gap-4"}
        [:div
         [attachments-view
          {:attachments     attachments
           :kpi-report      report
           :prevent-upload? prevent-upload?}]]]]
      (if loading?
        [:div.kpi-report-loading-info
         (loc/tr :loading-report-data)]
        [:div.kpi-report-empty-info
         (if (empty? all-reports)
           (loc/tr :no-kpi-reports)
           (loc/tr :kpi-report-has-been-deleted))]))))

(defn company
  [args]
  (let []
    (fn [{:keys [company-id is-guest?] :as args}]
      (let [sidenav-minimized? (:sidenav-minimized? @db/state)
            reports (->> @session/all-kpi-reports
                         ;;filters out old reports:
                         (filter :kpi-report/kpi-cycle)
                         (remove events/disabled-company?))
            lower-case (fnil string/lower-case "")
            companies (->> reports
                           (map :kpi-report/company)
                           distinct
                           (keep @session/entities)
                           (sort-by (fn-> :asset/name lower-case)))
            selected-company-id company-id
            company-reports (events/company-reports selected-company-id)
            selected-report-id (:selected-report @db/state)
            loading? (:loading? @db/state)
            company (session/get-entity selected-company-id)
            report (session/get-entity selected-report-id)
            kpi-cycle (->> report
                           :kpi-report/kpi-cycle
                           (get @session/entities))

            datas (->> @session/all-kpi-report-datas
                       (cu/only-entity :kpi-report-data/kpi-report selected-report-id))
            answers (->> @session/all-kpi-report-answers
                         (cu/only-entity :kpi-report-answer/kpi-report selected-report-id))]
        [:<>
         (if is-guest?
           [zap-toolbar/view db/state (partial guest-navigation-elems company) nil
            (guest-toolbar-actions
             {:report report
              :cycle  kpi-cycle}) nil #_(partial mode-selector db/state)]
           [zap-toolbar/view db/state (partial navigation-elems company) nil
            (toolbar-actions
             {:report report
              :cycle  kpi-cycle}) nil #_(partial mode-selector db/state)])
         [:div
          {:class "flex flex-1"}
          [company-sidenav/view
           {:minimized?         sidenav-minimized?
            :toggle-minimize!   events/toggle-sidenav!
            :companies          companies
            :company-id         selected-company-id
            :select-company!    events/select-company!
            :select-report!     events/select-report!
            :reports            company-reports
            :selected-report-id selected-report-id}]
          [:div
           {:class-name (fu/cs ""
                               (when sidenav-minimized? "named-view-minimized"))}
           [report-view
            {:is-guest? is-guest?
             :company   company
             :report    report
             :kpi-cycle kpi-cycle
             :loading?  loading?
             :datas     datas
             :answers   answers}]]]]))))

(defn render
  [args]
  (let [foo :bar]
    (fn [args]
      (let [mode @db/mode
            sidenav-minimized? (:sidenav-minimized? @db/state)]
        [default-page-layout/view
         {:class-name "zap-page kpi-summary"}
         [company args]]))))

(defn view
  [args]
  (r/create-class
   {:component-did-mount    (fn []
                              (events/setup (:company-id args)))
    :component-will-unmount (fn []
                              (events/cleanup))
    :reagent-render         render}))

(defmethod routing/render-view :kpi-company-reports
  [{:keys [route-params view-params]}]
  (let [company-id (-> route-params
                       :id
                       js/parseInt)
        available? (and (plan/available :feature/kpi-reporting @session/tenant @session/role)
                        (or (session/kpi-reporting?)
                            (session/sys-admin?)))
        {:keys [report category]} view-params
        selected-report (:selected-report @db/state)
        _ (when-not selected-report
            (cond report (events/select-report! (:db/id report))
                  category (events/select-report! (->> (events/company-reports company-id)
                                                       (filter (fn->> :kpi-report/kpi-cycle
                                                                      (get @session/entities)
                                                                      :kpi-cycle/kpi-category
                                                                      (= (:db/id category))))
                                                       first
                                                       :db/id))
                  :else nil))]
    (if-not available?
      [not-found/not-found-view]
      [view {:company-id company-id}])))

(defmethod routing/render-view :guest-kpi-reports
  [_]
  (if-not (and (= @session/role :role/guest-sell-side)
               (not= (->> @session/tenant
                          :tenant/product-plan
                          :features
                          :feature/kpi-reporting
                          :status)
                     :not-in-use))
    [not-found/not-found-view]
    [view
     {:is-guest?  true
      :company-id (-> @session/session
                      :target
                      :db/id)}]))
